import Component from '@glimmer/component';
import { type HeadlessFormFieldBlock } from '../../types.ts';
import type { FormData, FormKey } from 'ember-headless-form';

interface Signature<
  DATA extends object,
  KEY extends FormKey<FormData<DATA>> = FormKey<FormData<DATA>>
> {
  Element: HTMLSpanElement;
  Args: {
    field: HeadlessFormFieldBlock<DATA, KEY>;
  };
}

export default class FormErrorsComponent<
  DATA extends object,
  KEY extends FormKey<FormData<DATA>> = FormKey<FormData<DATA>>
> extends Component<Signature<DATA, KEY>> {
  <template>
    <span id={{@field.errorId}} class='text-red'>
      {{#each @field.rawErrors as |error|}}
        {{error.message}}
        <br />
      {{/each}}
    </span>
  </template>
}
